import { AuthService } from 'app/services/user/auth.service';
import { Injectable } from '@angular/core';
import { HttpClientService } from '../httpClient/httpclient.service';
import { Observable } from 'rxjs/Observable';
import { CustomerCluster, CustomerClusterDataToSend } from '../../models/loyalty-cluster.model';
import { ListMetadata } from '../../models/list-metadata.model';
import { HttpParams } from '@angular/common/http';

@Injectable()
export class CustomerClusterService {

  public baseUrl = '/koncentro-loyalty/cluster';
  public baseApiUrl = '/koncentro-api/custom';
  companyCode: number;

  constructor(
    private http: HttpClientService,
    private authService: AuthService
  ) {
    this.companyCode = this.authService.user.selectedCompany;
  }

  getByCustomerId(customerId: number): Observable<{ data: Array<CustomerCluster>, metadata: ListMetadata }> {
    return this.http.getPaged(`koncentro-api/customer/getCustomerClusterList?companyCode=${this.companyCode}&customerId=${customerId}`);
  }

  getClusterHead(id: number) {
    return this.http.getPaged(this.baseUrl + '/head/' + id);
  }

  getClusterHeadList(headDesc: string, customerId: string, clusterActive?: boolean): Observable<{ data: Array<CustomerCluster>, metadata: ListMetadata }> {
    let params: HttpParams = new HttpParams();
    params = params.set('offset', '0');
    params = params.set('limit', '100');

    if (clusterActive) {
      params = params.set('active', 'true');
    }


    if (headDesc) {
      params = params.set('headDescription', headDesc);
    }

    if (customerId) {
      params = params.set('customerId', customerId);
    }

    // return this.http.getPaged(this.baseUrl + '/getClusterHead', params.toString());
    return this.http.getPaged(this.baseUrl + '/getClusterHeadList', params.toString());
  }

  addCustomerCluster(cluster: CustomerClusterDataToSend) {
    return this.http.post(`koncentro-api/customer/addCustomerCluster?companyCode=${this.companyCode}`, cluster);
  }

  editCustomerCluster(cluster: CustomerClusterDataToSend) {
    return this.http.put(`koncentro-api/customer/updateCustomerCluster?companyCode=${this.companyCode}`, cluster);
  }

  deleteCustomerCluster(cluster: CustomerClusterDataToSend) {
    return this.http.delete(`/koncentro-api/customer/deleteCustomerCluster?companyCode=${this.companyCode}`, cluster);
  }

  saveCustomerClusterLoyalty(customerId) {
    return this.http.put(`${this.baseApiUrl}/loyaltyUpdate/${customerId}`, {});
  }

  getCustomerClusterCheckParam() {
    return this.http.get('koncentro-loyalty/params/getParam/CUSTOMER.CHECK.CLUSTER')
  }

  getClusterHeadAllList() {
    return this.http.get('koncentro-loyalty/cluster/getClusterHeadAllList?limit=99999');
  }

  getClusterHeadAllListWithParams(search?: Array<{ key: string, value: string }>): Observable<any> {

    const params: URLSearchParams = new URLSearchParams();
    if (search) {
      for (const filter of search) {
        params.set(filter.key, filter.value);
      }
    }
    return this.http.get(this.baseUrl + '/getClusterHeadAllList?' + params.toString());
  }

  getClusterHeadListSoloSchedaCliente(headDesc: string, customerId: string, clusterActive?: boolean): Observable<{ data: Array<CustomerCluster>, metadata: ListMetadata }> {
    let params: HttpParams = new HttpParams();
    params = params.set('offset', '0');
    params = params.set('limit', '100');

    if (clusterActive) {
      params = params.set('active', 'true');
      //KS-7794
      params = params.set('future', 'true');
    }

    if (headDesc) {
      params = params.set('headDescription', headDesc);
    }

    if (customerId) {
      params = params.set('customerId', customerId);
    }

    return this.http.getPaged(this.baseUrl + '/getClusterHeadListSchedaCliente', params.toString());
  }

}



// WEBPACK FOOTER //
// ./src/app/services/customer/customer-cluster.service.ts